<template>
    <div class="mloyout" >        
        <div class="L_R" v-if="type=='L_R'" :style="{justifyContent:just}"><slot></slot></div>
        <div class="T_B" v-if="type=='T_B'"><slot></slot></div>     
    </div>
</template>
<style lang="scss" scoped>
    .mloyout{
        flex:1;
         display: flex;
        .L_R{
            flex:1;
            display: flex;
           flex-direction: row;
          
        }
        .T_B{
            flex:1;
            display: flex;
           flex-direction: column;          
        }
    }     
</style>
<script>
export default {
    props:['type','just']
}
</script>